import config from '../config'
import axios from 'axios'

const logout = async() => {
    const response = await axios.get(config.API_BASE_URL + '/magicpoints/logout', { withCredentials: true })

    return response
}

export default logout